export const extractCollection = <T>(payload: unknown): T[] => {
  if (Array.isArray(payload)) {
    return payload as T[];
  }

  if (!payload || typeof payload !== "object") {
    return [];
  }

  const candidate = payload as {
    value?: unknown;
    items?: unknown;
    data?: unknown;
    result?: unknown;
  };

  if (Array.isArray(candidate.value)) {
    return candidate.value as T[];
  }

  if (Array.isArray(candidate.items)) {
    return candidate.items as T[];
  }

  if (Array.isArray(candidate.result)) {
    return candidate.result as T[];
  }

  if (candidate.data) {
    return extractCollection<T>(candidate.data);
  }

  return [];
};

export const extractFirst = <T>(payload: unknown): T | null => {
  const list = extractCollection<T>(payload);
  return list.length > 0 ? list[0] : null;
};

